import { companyCreationAxiosInstance } from '@bupa-monorepo/shared-frontend/admin/shared';

export const setShowOnePersonModal = (showModal: boolean): Promise<void> => {
  return companyCreationAxiosInstance.patch(
    `v1/customer/companyCreations/showModal/${showModal}`
  );
};
